import { Heading } from '@efdigital/ll-addon-ui';
import { IfCoach } from '@efdigital/ll-xceed-v2/components/user/rights/if-coach.gts';
import { IfCoachee } from '@efdigital/ll-xceed-v2/components/user/rights/if-coachee.gts';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface IndexSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Home"}}
  {{outlet}}

  <IfCoach>
    <:notCoach>
      <IfCoachee>
        <:notCoachee>
          <div class="container py-5">
            <Heading
              @size="lg"
              @text="Coaching isn't available for your account"
              @secondary="Your account isn't enrolled in a coaching program. If you were expecting access as a coachee or coach, please contact your program administrator."
              @class="mb-4"
            />
            <div class="alert alert-info mb-0" role="status">
              Think this is a mistake? Email
              <a
                href="mailto:v-support@hultashridge.com"
              >v-support@hultashridge.com</a>
              and we'll help.
            </div>
          </div>
        </:notCoachee>
      </IfCoachee>
    </:notCoach>
  </IfCoach>
</template> satisfies TOC<IndexSignature>;
